/* fz-ocu-onetap: Zipify OCU pre-purchase popup — "Add to Order" goes straight to checkout.
   OCU's multi-offer popup only *selects* an offer on "Add to Order" (no network, cart unchanged);
   the real work (cart/add.js?ocu -> accept -> verify -> /checkout) happens on "Continue".
   So after OCU flips the tapped offer into its selected state, we press OCU's own Continue.
   No timers for readiness: a MutationObserver waits for OCU's selected state. */
(function () {
  if (window.__fzOcuOneTap) return; window.__fzOcuOneTap = true;
  var POP = 'dialog.ocu-popup.ocu-pre';            // pre-purchase dialog (name="multiple_popup")
  var BUY = '.ocu-order-button__buy';              // "Add to Order"  (data-testid="not-selected-button")
  var SEL = '.ocu-order-button__selected-text';    // "Add to Order (1)" = offer selected
  var GO = '.ocu-proceed';                         // "Continue"      (data-testid="proceed")
  var FEEDBACK_MS = 250;                           // let the shopper see "Add to Order (1)" flash; not a readiness wait
  var GIVE_UP_MS = 4000;                           // OCU never selected it (sold out / error): leave Continue to the shopper
  var sent = typeof WeakSet === 'function' ? new WeakSet() : { has: function () { return false; }, add: function () {}, delete: function () {} };

  // back/forward cache restore: OCU may show the same dialog again, so re-arm
  window.addEventListener('pageshow', function (e) { if (e.persisted && typeof WeakSet === 'function') sent = new WeakSet(); });

  window.addEventListener('click', function (e) {
    if (window.FZ_OCU_ONETAP === false) return;                     // kill switch (theme setting / console)
    var btn = e.target && e.target.closest && e.target.closest(BUY);
    if (!btn) return;
    var pop = btn.closest(POP);
    if (!pop || sent.has(pop)) return;
    var before = pop.querySelectorAll(SEL).length, finished = false, timer;
    var mo = new MutationObserver(check);
    function stop() { finished = true; mo.disconnect(); clearTimeout(timer); }
    function check() {
      if (finished || pop.querySelectorAll(SEL).length <= before) return;
      stop();
      setTimeout(proceed, FEEDBACK_MS);
    }
    function proceed() {
      if (sent.has(pop) || !pop.isConnected || !pop.open) return;   // popup closed / timer ran out
      if (!pop.querySelector(SEL)) return;                          // shopper hit the X on the added state
      var go = pop.querySelector(GO);
      if (!go || go.disabled || go.getAttribute('aria-disabled') === 'true') return;
      sent.add(pop);
      pop.addEventListener('close', function () { sent.delete(pop); }, { once: true }); // re-arm if OCU closes without leaving
      go.click();                                                   // OCU does add + discount + redirect itself
    }
    mo.observe(pop, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-testid'] });
    timer = setTimeout(stop, GIVE_UP_MS);
    check();
  }, true); // capture on window: OCU stops a real tap's click before it bubbles to document.
            // We only take a snapshot here; OCU's own handler still runs, we act when its DOM flips.
})();
